// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PurchaseHistoryManagement-purchaseHistoryPlanInfo-VKvjz {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 12px;
}

.PurchaseHistoryManagement-purchaseHistoryPlanHead-n_LR8 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 6px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.PurchaseHistoryManagement-purchaseHistoryPlanTitle-dc4rg {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    color: var(--primary-foreground);
}

.PurchaseHistoryManagement-purchaseHistoryPlanImgBox-RLyJE {
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background-color: var(--tertiary-gray-bg);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.PurchaseHistoryManagement-purchaseHistoryPlanImg-MLqNO {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
}

.PurchaseHistoryManagement-purchaseHistoryPlanFeatureList-YKS7j {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 6px;
}

.PurchaseHistoryManagement-purchaseHistoryPlanListItem-QyxmJ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 6px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--primary-foreground);
}

.PurchaseHistoryManagement-purchaseHistoryTableLink-PJO73 {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicePlanContainer/PurchaseHistory/PurchaseHistoryManagement/PurchaseHistoryManagement.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,QAAQ;IACR,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,0BAAuB;OAAvB,uBAAuB;IACvB,wCAAgC;QAAhC,oCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".purchaseHistoryPlanInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.purchaseHistoryPlanHead {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n\n.purchaseHistoryPlanTitle {\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n}\n\n.purchaseHistoryPlanImgBox {\n    position: relative;\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    background-color: var(--tertiary-gray-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.purchaseHistoryPlanImg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 12px;\n    height: 12px;\n    object-fit: cover;\n    object-position: center;\n    transform: translate(-50%, -50%);\n}\n\n.purchaseHistoryPlanFeatureList {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.purchaseHistoryPlanListItem {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n}\n\n.purchaseHistoryTableLink {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"purchaseHistoryPlanInfo": `PurchaseHistoryManagement-purchaseHistoryPlanInfo-VKvjz`,
	"purchaseHistoryPlanHead": `PurchaseHistoryManagement-purchaseHistoryPlanHead-n_LR8`,
	"purchaseHistoryPlanTitle": `PurchaseHistoryManagement-purchaseHistoryPlanTitle-dc4rg`,
	"purchaseHistoryPlanImgBox": `PurchaseHistoryManagement-purchaseHistoryPlanImgBox-RLyJE`,
	"purchaseHistoryPlanImg": `PurchaseHistoryManagement-purchaseHistoryPlanImg-MLqNO`,
	"purchaseHistoryPlanFeatureList": `PurchaseHistoryManagement-purchaseHistoryPlanFeatureList-YKS7j`,
	"purchaseHistoryPlanListItem": `PurchaseHistoryManagement-purchaseHistoryPlanListItem-QyxmJ`,
	"purchaseHistoryTableLink": `PurchaseHistoryManagement-purchaseHistoryTableLink-PJO73`
};
module.exports = ___CSS_LOADER_EXPORT___;
